/**
 * Created by Ning Jiang on 11/22/2016.
 */

import "pixi-spine";
// keep these imports after "pixi" is added to window"
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombOfAkhenatenGameModuleConfig} from "./TombOfAkhenatenGameModuleConfig";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TOAGameRoundManager} from "./gameround/TOAGameRoundManager";
import {TOATimelineReelsController} from "./reel/TOATimelineReelsController";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "./events/TOAGameEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAWinFieldController} from "./winpresentation/initial/TOAWinFieldController";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";

require("gsap");

export class TombOfAkhenaten extends SlotGame {
    public static timelineReelsController:TimelineReelsController;
    public static gameRoundManager:GameRoundManager;

    /**
     * @constructs
     */
    constructor() {
        super(TombOfAkhenatenGameModuleConfig.instance);
    }

    /**
     * @inheritDoc
     * initGame using Jonas.W framework
     */
    protected initGame():void {
        if(TombOfAkhenatenGameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            TombOfAkhenaten.timelineReelsController = TimelineReelsController.instance;
            const gameRoundConfig = TombOfAkhenatenGameModuleConfig.instance.GAME_ROUND_CONFIG();
            (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).init(gameRoundConfig);
            TombOfAkhenaten.gameRoundManager = new TOAGameRoundManager(gameRoundConfig);
        } else {
            super.initGame();
        }
    }

    protected createWinFieldController(): WinFieldController {
        return new TOAWinFieldController();
    }

    start(): Promise<NolimitPlugin> {
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_GAME_START));
        return super.start();
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L1",
                    "L2",
                    "M4",
                    "M5",
                    "L4"
                ],
                [
                    "S",
                    "M3",
                    "M1",
                    "M4",
                    "M5"
                ],
                [
                    "S",
                    "L4",
                    "M3",
                    "L1",
                    "L3"
                ],
                [
                    "L1",
                    "L3",
                    "L4",
                    "L1",
                    "M1"
                ],
                [
                    "L2",
                    "M1",
                    "L3",
                    "L2",
                    "M5"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "X",
                    "M4",
                    "M5",
                    "L4"
                ],
                [
                    "X",
                    "X",
                    "M1",
                    "M4",
                    "M5"
                ],
                [
                    "X",
                    "X",
                    "M3",
                    "L1",
                    "L3"
                ],
                [
                    "X",
                    "X",
                    "L4",
                    "L1",
                    "M1"
                ],
                [
                    "X",
                    "X",
                    "L3",
                    "L2",
                    "M5"
                ]
            ],
            "evaluatedAreaUpdated": [
                [
                    "X",
                    "X",
                    "M4",
                    "M5",
                    "L4"
                ],
                [
                    "X",
                    "X",
                    "M1",
                    "M4",
                    "M5"
                ],
                [
                    "X",
                    "X",
                    "M3",
                    "L1",
                    "L3"
                ],
                [
                    "X",
                    "X",
                    "L4",
                    "L1",
                    "M1"
                ],
                [
                    "X",
                    "X",
                    "L3",
                    "L2",
                    "M5"
                ]
            ],
            "betWayWins": [],
            "betWayWinsUpdated": [],
            "totalBetWayWins": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "scatterPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "addedNumberOfFreespinsThisSpin": 0,
            "stickySymbols": [
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "activeRows": 3,
            "activeRowsNextSpin": 3,
            "allWinningPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "allWinningPositionsUpdated": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "payoutMultiplierBefore": 1,
            "payoutMultiplier": 1,
            "payoutMultiplierNextSpin": 1,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 65
                },
                {
                    "name": "FREESPIN_5_SCATTERS",
                    "type": "FREESPIN",
                    "price": 105
                }
            ],
            "wasFeatureBuy": false,
            "extraWildPosition": [
                -1,
                -1
            ],
            "awardedSpins": 0,
            "finalSpinWildPositions": [],
            "wildMultipliers": [
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "pyramidReelLand": [
                false,
                false,
                false,
                false,
                false
            ],
            "showPyramidsReel": [
                false,
                false,
                false,
                false,
                false
            ],
            "fullScreen": false
        };
    }

    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (TombOfAkhenaten.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }
}